import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEECONTRACTTYPE,
  DELETE_EMPLOYEECONTRACTTYPE,
  UPDATE_EMPLOYEECONTRACTTYPE,
  ADD_NEW_EMPLOYEECONTRACTTYPE,
} from "./actionType";

import {
  getEmployeeContractTypeSuccess,
  getEmployeeContractTypeFail,
  deleteEmployeeContractTypeSuccess,
  deleteEmployeeContractTypeFail,
  updateEmployeeContractTypeSuccess,
  updateEmployeeContractTypeFail,
  addEmployeeContractTypeSuccess,
  addEmployeeContractTypeFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getEmployeeContractTypeApi,
  updateEmployeeContractTypeApi,
  deleteEmployeeContractTypeApi,
  addNewEmployeeContractTypeApi
} from "../../helpers/backend_helper";

function* getEmployeeContractType({ payload: employeeContractType }) {
  try {
    const response = yield call(getEmployeeContractTypeApi, employeeContractType);
    yield put(getEmployeeContractTypeSuccess(GET_EMPLOYEECONTRACTTYPE, response.data));
  } catch (error) {
    yield put(getEmployeeContractTypeFail(GET_EMPLOYEECONTRACTTYPE, error));
  }
}

function* onUpdateEmployeeContractType({ payload: employeeContractType }) {
  try {
    const response = yield call(updateEmployeeContractTypeApi, employeeContractType);
    yield put(updateEmployeeContractTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateEmployeeContractTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeContractType({ payload: employeeContractType }) {
  try {
    const response = yield call(deleteEmployeeContractTypeApi, employeeContractType);
    yield put(deleteEmployeeContractTypeSuccess({ employeeContractType, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeContractTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeContractType({ payload: employeeContractType }) {
  try {
    const response = yield call(addNewEmployeeContractTypeApi, employeeContractType);
    yield put(addEmployeeContractTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeContractTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeContractType() {
  yield takeEvery(GET_EMPLOYEECONTRACTTYPE, getEmployeeContractType);
}

export function* watchUpdateEmployeeContractType() {
  yield takeEvery(UPDATE_EMPLOYEECONTRACTTYPE, onUpdateEmployeeContractType);
}

export function* watchDeleteEmployeeContractType() {
  yield takeEvery(DELETE_EMPLOYEECONTRACTTYPE, onDeleteEmployeeContractType);
}

export function* watchAddNewEmployeeContractType() {
  yield takeEvery(ADD_NEW_EMPLOYEECONTRACTTYPE, onAddNewEmployeeContractType);
}

function* employeeContractTypeSaga() {
  yield all([
    fork(watchGetEmployeeContractType),
    fork(watchDeleteEmployeeContractType),
    fork(watchUpdateEmployeeContractType),
    fork(watchAddNewEmployeeContractType)
  ]);
}

export default employeeContractTypeSaga;
